import React from 'react';
import { motion } from 'framer-motion';
import { FiChevronRight, FiCheckCircle, FiCircle, FiInfo } from 'react-icons/fi';

const RoadmapNode = ({ node, level = 0 }) => {
    const [isOpen, setIsOpen] = React.useState(level < 1); // Open first level by default

    const hasChildren = node.children && node.children.length > 0;

    return (
        <div style={{ marginLeft: level * 20, marginBottom: 12 }}>
            <motion.div
                layout
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '12px 16px',
                    borderRadius: 16,
                    background: 'rgba(255, 255, 255, 0.03)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    cursor: hasChildren ? 'pointer' : 'default',
                    transition: 'all 0.3s ease'
                }}
                onClick={() => hasChildren && setIsOpen(!isOpen)}
                whileHover={{ background: 'rgba(34, 197, 94, 0.05)', borderColor: 'rgba(34, 197, 94, 0.3)' }}
            >
                <div style={{ color: node.isCompleted ? '#22c55e' : '#22c55e' }}>
                    {node.isCompleted ? <FiCheckCircle size={20} /> : <FiCircle size={20} />}
                </div>

                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#fff' }}>{node.title}</div>
                    {node.description && <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginTop: 2 }}>{node.description}</div>}
                </div>

                {hasChildren && (
                    <motion.div animate={{ rotate: isOpen ? 90 : 0 }}>
                        <FiChevronRight size={18} color="#64748b" />
                    </motion.div>
                )}
            </motion.div>

            {hasChildren && isOpen && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    style={{ overflow: 'hidden', marginTop: 12, borderLeft: '2px solid rgba(34, 197, 94, 0.2)', marginLeft: 10, paddingLeft: 10 }}
                >
                    {node.children.map((child, idx) => (
                        <RoadmapNode key={idx} node={child} level={0} />
                    ))}
                </motion.div>
            )}
        </div>
    );
};

const RoadmapView = ({ data }) => {
    if (!data || !data.nodes) {
        return (
            <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
                <FiInfo size={40} style={{ marginBottom: 16, opacity: 0.5 }} />
                <p>No valid roadmap data found.</p>
            </div>
        );
    }

    return (
        <div className="roadmap-container" style={{ padding: '20px 0' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 900, color: '#fff', marginBottom: 32, display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 4, height: 24, background: '#22c55e', borderRadius: 2 }} />
                Interactive Roadmap
            </h2>

            <div className="roadmap-tree">
                {data.nodes.map((node, idx) => (
                    <RoadmapNode key={idx} node={node} />
                ))}
            </div>

            <style>{`
        .roadmap-tree {
          max-width: 800px;
          margin: 0 auto;
        }
      `}</style>
        </div>
    );
};

export default RoadmapView;
